import React, { Component } from 'react';

//componentes
import Footer from './footer'

class Index extends Component {

    render(){
        return(
            <div>
                <Footer />
            </div>
        );
    }

}
export default Index;